import React from "react";
import ReactSpeedometer from "react-d3-speedometer";

const generateTicks = (min, max, totalTicks = 50) => {
  const ticks = [];
  const step = (max - min) / totalTicks;

  for (let i = 0; i <= totalTicks; i++) {
    const value = min + i * step;
    const angle = ((value - min) / (max - min)) * 180 - 180;
    const rad = (angle * Math.PI) / 180;

    const radiusOuter = i % 5 === 0 ? 180 : 175;;
    const radiusInner = i % 5 === 0 ? 165 : 165; // longer every 5th tick

    ticks.push({
      x1: 200 + radiusOuter * Math.cos(rad),
      y1: 200 + radiusOuter * Math.sin(rad),
      x2: 200 + radiusInner * Math.cos(rad),
      y2: 200 + radiusInner * Math.sin(rad),
      isMajor: i % 5 === 0,
    });
  }

  return ticks;
};

const SpeedometerWithScale = (props) => {
  const min = props.minValue;
  const max =   props.maxValue;
  const ticks = generateTicks(min, max, 50); // 50 small ticks

  return (
    <div style={{ position: "relative", width: 240, height: 240 }}>
      <ReactSpeedometer
        minValue={min}
        maxValue={max}
        value={props.value}
        segments={props.segments || 10}
        width={props.width || 240}
        height={props.height || 240}
        ringWidth={props.ringWidth || 15}
        segmentColors={props.segmentColors}
        currentValueText= {props.currentValueText || ""}
        needleColor={props.needleColor || "#000000"}
        textColor={props.textColor || "#000000"}
        needleTransitionDuration={props.needleTransitionDuration || 1000}
        needleTransition="easeElastic"
        customSegmentStops={props.customSegmentStops || []}
        labelFontSize={props.labelFontSize || "10px"}
        customSegmentLabels={props.customSegmentLabels || []}
        
      />

      <svg
        viewBox="0 0 400 400"
        style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }}
      >
        {ticks.map((tick, i) => (
          <line
            key={i}
            x1={tick.x1}
            y1={tick.y1}
            x2={tick.x2}
            y2={tick.y2}
            stroke={tick.isMajor ? "#000" : "#999"}
            strokeWidth={tick.isMajor ? 3 : 2}
          />
        ))}
      </svg>
    </div>
  );
};

export default SpeedometerWithScale;
